import { mutator } from 'satcheljs';
import {
    updateFilteredOptions,
    resetFilteredOptions,
} from '../actions/filteredPickerOptionsActions';

mutator(updateFilteredOptions, ({ viewState, options }) => {
    viewState.filteredOptions = options;
});

mutator(resetFilteredOptions, ({ viewState }) => {
    viewState.filteredOptions = viewState.options;
});
